import React from "react";
import {
  VOTE_MODAL,
  BUY_MODAL,
  CODE_MODAL,
  ADD_CREDITS_MODAL,
  ADD_CREDITS_SUCCESS_MODAL,
  VOTED_SUCCESS_MODAL,
  CREDIT_CARD_MODAL,
  ADD_SONG_TO_RADIO_MODAL,
  DOWNLOAD_APP_MODAL,
  DOWNLOAD_APP_REDEEM_MODAL,
  TERMS_AND_CONDITIONS_MODAL,
} from "../../constants";
import BuyModal from "./BuyModal";
import CodeModal from "./CodeModal";
import VoteModal from "./VoteModal";
import VotedSuccessModal from "./VotedSuccessModal";
import AddCreditsModal from "./AddCreditsModal";
import AddCreditSuccessModal from "./AddCreditSuccessModal";
import CreditCardsModal from "./CreditCardsModal";
import AddSongToRadioModal from "./AddSongToRadioModal";
import DownloadAppModal from "./DownloadAppModal";
import DownloadAppRedeemModal from "./DownloadAppRedeemModal";
import TermsAndConditionsModal from "./TermsAndConditionsModal";

const modals = {};
modals[VOTE_MODAL] = (params) => <VoteModal {...params} />;
modals[BUY_MODAL] = (params) => <BuyModal {...params} />;
modals[CODE_MODAL] = (params) => <CodeModal {...params} />;
modals[ADD_CREDITS_MODAL] = (params) => <AddCreditsModal {...params} />;
modals[ADD_CREDITS_SUCCESS_MODAL] = (params) => (
  <AddCreditSuccessModal {...params} />
);
modals[VOTED_SUCCESS_MODAL] = (params) => <VotedSuccessModal {...params} />;
modals[CREDIT_CARD_MODAL] = (params) => <CreditCardsModal {...params} />;
modals[ADD_SONG_TO_RADIO_MODAL] = (params) => (
  <AddSongToRadioModal {...params} />
);
modals[DOWNLOAD_APP_MODAL] = (params) => <DownloadAppModal {...params} />;
modals[DOWNLOAD_APP_REDEEM_MODAL] = (params) => (
  <DownloadAppRedeemModal {...params} />
);
modals[TERMS_AND_CONDITIONS_MODAL] = (params) => (
  <TermsAndConditionsModal {...params} />
);

export default modals;
